export default {
  BASIC:   'basic',
  BIO:     'bio',
  PROMPTS: 'prompts',
  SOCIAL:  'social'
};
